import type { WallCard } from '@walls/store';

interface PlacementOptions {
  dropPosition: { x: number; y: number } | null;
  existingCards: WallCard[];
}

export function getNewCardPlacement({ dropPosition, existingCards }: PlacementOptions) {
  if (dropPosition) {
    return { xPos: dropPosition.x, yPos: dropPosition.y };
  }

  const topCard = existingCards
    .filter((card) => !card.parentId)
    .sort((a, b) => (b.zPos ?? 0) - (a.zPos ?? 0))[0];

  if (topCard) {
    return {
      xPos: topCard.xPos ?? Math.floor(window.innerWidth / 2) - 100,
      yPos: (topCard.yPos ?? Math.floor(window.innerHeight / 2) - 39) + (topCard.height ?? 80) + 5,
    };
  }

  return {
    xPos: Math.floor(window.innerWidth / 2) - 100,
    yPos: Math.floor(window.innerHeight / 2) - 39,
  };
}
